module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./MessageEventsView.js"));
	}, "MessageEventsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MessageEventsView!./src/pages/MessageManage/MessageEvents/MessageEventsView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=MessageEventsView!./src/pages/MessageManage/MessageEvents/MessageEventsView.js
// module chunks = 43